import { useState } from "react";
import { Link } from "react-router-dom";
import {
  TbBallFootball,
  TbBarbell,
  TbBike,
  TbBuildingCommunity,
  TbChartArrowsVertical,
  TbKarate,
  TbLayoutGrid,
  TbMoodKid,
  TbMusic,
  TbRocket,
  TbRosetteDiscountCheck,
  TbSchool,
  TbStretching2,
  TbSwimming,
  TbUserBolt,
  TbYoga,
} from "react-icons/tb";
import { L } from "../../../../constants/baysportLabels";
import { TRIAL_DAYS } from "../../../../constants/trial";
import { LANDING_PRICE_FROM } from "../../HomeLanding/landingSeo";
import { Btn } from "../SiteShell";
import InlineRegister from "../InlineRegister";
import { BASE, isAudienceMenuPath, IMG, PATHS } from "../nav";
import site from "../site.module.css";
import h from "./home.module.css";
import { PageSeo } from "../seo";
import { FaqList, formatRub, PlansCalculator, Title, usePublicPlans } from "./parts";

const ICON_PATHS = {
  calendar: "M7 3v3M17 3v3M4 9h16M5 5h14a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1Z",
  users: "M16 19v-1a4 4 0 0 0-4-4H7a4 4 0 0 0-4 4v1M9.5 10a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM21 19v-1a4 4 0 0 0-3-3.9M16 4.1a3 3 0 0 1 0 5.8",
  card: "M3 7h18M3 7a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V7ZM7 14h4",
  phone: "M8 3h8a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1ZM11 18h2",
};

function Icon({ name }) {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden>
      <path
        d={ICON_PATHS[name]}
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

const MOCK = "/landing";

const APP_TABS = [
  {
    id: "owner",
    label: "Руководителю",
    title: ["Рабочий день —", "перед глазами"],
    text: "Сводка дня, календарь занятий, журнал и клиенты — в телефоне владельца и администратора. Видно, что требует внимания, без поиска по таблицам.",
    points: ["Сводка и «требует внимания»", "Календарь и журнал посещений", "Клиенты и финансы"],
    screens: ["mock-owner-calendar.png", "mock-owner-home.png", "mock-owner-journal.png"],
  },
  {
    id: "client",
    label: "Клиенту",
    title: ["Быть на связи", "со своим клубом"],
    text: "Клиент видит расписание, свои посещения и остаток абонемента, может написать в чат клуба. Если в клубе включена запись — записывается сам.",
    points: ["Расписание и посещения", "Абонемент и остаток", "Чат с клубом"],
    screens: ["mock-client-calendar.png", "mock-client-home.png", "mock-client-chat.png"],
  },
  {
    id: "brand",
    label: "Бренд клуба",
    title: ["Приложение", "под вашим именем"],
    text: "Логотип, обложка и цвета клуба. Лента новостей, участники и чат — клиенты открывают ваш клуб, а не чужой сервис.",
    points: ["Логотип и цвета клуба", "Лента и участники", "Свой экран загрузки"],
    screens: ["mock-brand-splash.png", "mock-brand-club.png", "mock-brand-manage.png"],
  },
];

const STRIP = [
  ["calendar", "Расписание", "Группы, залы, тренеры и филиалы."],
  ["users", "Журнал посещений", "Тренер отмечает группу — занятия списываются сами."],
  ["card", "Абонементы и оплаты", "Остатки, заморозки, должники и онлайн-оплата."],
  ["phone", "Приложение клуба", "Расписание, абонемент и чат у клиента в телефоне."],
];

const NICHES = [
  ["Фитнес-клубы", TbBarbell, `${BASE}/dlya-fitnesa`],
  ["Йога и пилатес", TbYoga, `${BASE}/dlya-yogi`],
  ["Школы танцев", TbMusic, `${BASE}/dlya-tancev`],
  ["Единоборства", TbKarate, `${BASE}/dlya-edinoborstv`],
  ["Бассейны", TbSwimming, `${BASE}/dlya-plavaniya`],
  ["Детские секции", TbMoodKid, null],
  ["Студии растяжки", TbStretching2, `${BASE}/dlya-rastyazhki`],
  ["Сайкл-студии", TbBike, `${BASE}/dlya-saykla`],
  ["Командный спорт", TbBallFootball, `${BASE}/dlya-futbola`],
  ["Спортивные школы", TbSchool, null],
  ["Персональный тренинг", TbUserBolt, null],
  ["Сети клубов", TbBuildingCommunity, null],
];

const PRINCIPLES = [
  [
    TbRocket,
    "Начинаете работать сразу",
    "Без долгого обучения и интеграторов: создали клуб, добавили группы и тренеров — и работаете.",
  ],
  [
    TbChartArrowsVertical,
    "Растёт вместе с клубом",
    "От одного тренера до сети залов: меняете тариф и подключаете модули, а клиенты и история остаются на месте.",
  ],
  [
    TbLayoutGrid,
    "Всё в одной системе",
    "Расписание, клиенты, абонементы и финансы — вместо тетрадей, таблиц и переписок в мессенджерах.",
  ],
  [
    TbRosetteDiscountCheck,
    "Понятная цена",
    `От ${formatRub(LANDING_PRICE_FROM)} ₽ в месяц за клуб. ${TRIAL_DAYS} дней бесплатно, без привязки карты.`,
  ],
];

const ROLES = [
  [IMG.a, "Руководителю", "Выручка, посещаемость и должники на одном экране. Видно, какие группы заполнены, а какие пустуют.", "Клуб под контролем"],
  [IMG.b, "Администратору", "Клиенты, абонементы и оплаты в одном месте. Продать абонемент или принять оплату — пара кликов.", "Меньше рутины на стойке"],
  [IMG.c, "Тренеру", "Свои группы, расписание и журнал. Отметил пришедших — занятия списались с абонементов сами.", "Время на тренировку"],
  [IMG.hero, "Клиенту", "Расписание, остаток занятий и оплата абонемента в приложении клуба. Новости и чат — там же.", "Клуб всегда под рукой"],
];

const FAQ = [
  [
    "Как понять, подходит ли сервис нашему формату?",
    `Проще всего попробовать: создайте клуб, заведите пару групп и пригласите тренера. ${TRIAL_DAYS} дней полного доступа хватит, чтобы проверить сервис на реальном расписании.`,
  ],
  [
    "Можно ли перенести клиентскую базу из таблиц?",
    "Да. Сохраните таблицу из Excel или Google Таблиц в CSV и загрузите — клиенты появятся в базе клуба.",
  ],
  [
    "Сколько стоит и есть ли пробный период?",
    `Тарифы — от ${formatRub(LANDING_PRICE_FROM)} ₽ в месяц за клуб. Первые ${TRIAL_DAYS} дней — полный доступ бесплатно, карту привязывать не нужно.`,
  ],
  [
    "Нужно ли устанавливать программу или нанимать программиста?",
    "Нет. Бай.Спорт работает в браузере на компьютере и телефоне. Запустить клуб можно за один вечер.",
  ],
  [
    "Как клиенты попадут в приложение клуба?",
    "Клиент открывает ссылку на ваш клуб и сохраняет её на главный экран телефона. Приложение — под вашим логотипом и цветами, без App Store и Google Play.",
  ],
  [
    "Можно ли принимать оплату онлайн?",
    "Да, в тарифах «Клуб» и «Про». Подключите ЮKassa или Т-Банк в настройках клуба — клиент оплачивает абонемент в приложении, деньги приходят на ваш счёт.",
  ],
  [
    "Подойдёт ли сервис для сети или нескольких залов?",
    "Да. Филиалы, залы, направления и тренеры настраиваются отдельно, а владелец видит общую картину по всем площадкам.",
  ],
];

export default function HomePage() {
  const [appTab, setAppTab] = useState(APP_TABS[0].id);
  const tab = APP_TABS.find((t) => t.id === appTab) || APP_TABS[0];
  const { plans, modules } = usePublicPlans();

  return (
    <div className={h.home}>
      <PageSeo page="home" faq={FAQ} />

      <section className={h.hero}>
        <div className={`${h.wrap} ${h.heroGrid}`}>
          <div>
            <h1>
              <span className={h.pill}>CRM для спортивного клуба</span>
              <span>Больше спорта.</span>
              <span>Меньше рутины.</span>
            </h1>
            <p className={h.heroLead}>
              {L.productName} объединяет расписание, клиентов и абонементы.
              Чтобы ваша команда занималась клубом, а не таблицами.
            </p>
            <div className={h.heroActions}>
              <Btn className={site.btnLg}>Создать клуб бесплатно</Btn>
              <Link to={PATHS.features} className={h.link}>
                Как это работает ↗
              </Link>
            </div>
            <p className={h.heroNote}>
              {TRIAL_DAYS} дней полного доступа • без привязки карты
            </p>
          </div>

          <div className={h.collage} aria-hidden>
            <div className={h.collagePhoto}>
              <img src={IMG.hero} alt="" />
            </div>
            <div className={`${h.float} ${h.floatStat}`}>
              <small>Посещения за неделю</small>
              <b>
                248<em>↑ 12%</em>
              </b>
              <div className={h.bars}>
                {[40, 55, 48, 70, 62, 84, 100].map((v, i) => (
                  <i key={i} style={{ height: `${v}%` }} />
                ))}
              </div>
            </div>
            <div className={`${h.float} ${h.floatClass}`}>
              <small>Сегодня · 19:00 · зал 1</small>
              <b>Пилатес, Анна</b>
              <div className={h.meter}>
                <i style={{ width: "83%" }} />
              </div>
              <div className={h.meterRow}>
                Пришли <span>10 из 12</span>
              </div>
            </div>
            <img
              src={`${MOCK}/mock-brand-manage.png`}
              alt=""
              className={h.heroPhone}
            />
          </div>
        </div>
      </section>

      <div className={h.strip}>
        <div className={`${h.wrap} ${h.stripGrid}`}>
          {STRIP.map(([icon, t, d]) => (
            <article key={t} className={h.stripCard}>
              <div className={h.stripIcon}>
                <Icon name={icon} />
              </div>
              <h3>{t}</h3>
              <p>{d}</p>
            </article>
          ))}
        </div>
      </div>

      <section className={h.section}>
        <div className={h.wrap}>
          <div className={h.head}>
            <p className={h.kicker}>01 / Возможности</p>
            <Title lines={["Автоматизируем всё,", "что отвлекает от спорта"]} />
            <p className={h.sub}>
              Расписание, списание занятий, уведомления и оплаты работают сами.
              Команде остаётся тренировать.
            </p>
          </div>

          <div className={h.grid2}>
            <article className={h.card}>
              <h3>Расписание групп и тренеров</h3>
              <p>
                Группы, персональные занятия, залы и филиалы. Работайте с
                постоянным составом групп или включите онлайн-запись — как
                удобно клубу.
              </p>
              <div className={h.ui}>
                <div className={h.uiTop}>
                  Сегодня в клубе <span className={h.uiTag}>РАСПИСАНИЕ</span>
                </div>
                <div className={h.uiRow}>
                  <div>
                    <b>09:00 · Пилатес</b>
                    <small>Анна · зал 1</small>
                  </div>
                  <em>8 человек</em>
                </div>
                <div className={h.uiRow}>
                  <div>
                    <b>19:00 · Дзюдо, младшая группа</b>
                    <small>Михаил · зал 2</small>
                  </div>
                  <em>15 человек</em>
                </div>
              </div>
            </article>
            <article className={h.card}>
              <h3>Абонемент считает себя сам</h3>
              <p>
                Тренер отмечает группу в журнале — занятия списываются, остаток
                обновляется у клиента в приложении. Должники видны сразу.
              </p>
              <div className={h.ui}>
                <p className={h.uiLabel}>Что происходит после отметки</p>
                <div className={h.path}>Отметка в журнале → Списано 1 занятие</div>
                <div className={h.path}>Осталось 2 → Клиент видит в приложении</div>
                <div className={h.path}>Оплата в приложении → Абонемент продлён</div>
              </div>
            </article>
          </div>

          <div className={`${h.grid3} ${h.mt}`}>
            <article className={h.card}>
              <h3>Финансы клуба</h3>
              <p>
                Выручка, расходы и долги — наличные, переводы и онлайн-оплаты в
                одном журнале.
              </p>
              <span className={h.chip}>Долг: 3 клиента</span>
            </article>
            <article className={h.card}>
              <h3>Продление без звонков</h3>
              <p>
                Клиент видит остаток занятий в приложении и сам оплачивает новый
                абонемент, когда они заканчиваются.
              </p>
              <span className={h.chip}>Абонемент продлён · 8 занятий</span>
            </article>
            <article className={h.card}>
              <h3>Связь без мессенджеров</h3>
              <p>
                Чат клуба, лента новостей и push-уведомления об изменениях в
                расписании.
              </p>
              <span className={h.chip}>Занятие перенесено на 19:30</span>
            </article>
          </div>

          <div className={h.ask}>
            <div>
              <h3>Проверьте на своём клубе</h3>
              <p>
                Создайте клуб, заведите группы и пригласите тренера — за вечер.
                {` ${TRIAL_DAYS}`} дней полного доступа бесплатно.
              </p>
            </div>
            <Btn>Создать клуб</Btn>
          </div>
        </div>
      </section>

      <section className={h.band}>
        <div className={h.wrap}>
          <div className={h.head}>
            <p className={h.kicker}>02 / Всё в одном</p>
            <Title lines={["Не нужно собирать клуб", "из десяти сервисов."]} />
            <p className={h.sub}>
              Приложение, уведомления и учёт уже внутри {L.productName}. Снаружи —
              только ваш банк для приёма оплаты.
            </p>
          </div>
          <div className={h.bandGrid}>
            <article className={`${h.bandCard} ${h.bandWide}`}>
              <h3>Онлайн-оплата на счёт клуба</h3>
              <p>
                Подключите эквайринг банка в настройках клуба — клиент оплачивает
                абонемент или разовое занятие в приложении, деньги приходят
                напрямую вам.
              </p>
              <div className={h.tags}>
                <span>ЮKassa</span>
                <span>Т-Банк</span>
              </div>
            </article>
            <article className={`${h.bandCard} ${h.bandWide}`}>
              <h3>Приложение клуба для клиентов</h3>
              <p>
                Открывается по ссылке, без App Store и Google Play. Логотип и
                цвета клуба — модулем «Брендинг» или в тарифе «Про».
              </p>
              <div className={h.tags}>
                <span>Расписание</span>
                <span>Абонемент</span>
                <span>Чат</span>
                <span>Лента клуба</span>
              </div>
            </article>
            <article className={h.bandCard}>
              <h3>Push-уведомления</h3>
              <p>
                Напоминания о занятиях, переносы и новости клуба — сразу на
                телефон клиента.
              </p>
            </article>
            <article className={h.bandCard}>
              <h3>Приглашение по QR</h3>
              <p>
                Клиент сканирует код на стойке или переходит по ссылке — и уже в
                вашем клубе.
              </p>
            </article>
            <article className={h.bandCard}>
              <h3>Перенос базы</h3>
              <p>Загрузка клиентов из CSV — из Excel или Google Таблиц.</p>
            </article>
          </div>
          <div className={h.bandFoot}>
            <span>
              Состав возможностей зависит от тарифа — подробности в сравнении.
            </span>
            <Link to={PATHS.pricing}>Сравнить тарифы ↗</Link>
          </div>
        </div>
      </section>

      <section className={`${h.section} ${h.soft}`} id="app">
        <div className={h.wrap}>
          <div className={h.headRow}>
            <div>
              <p className={h.kicker}>03 / Клуб в телефоне</p>
              <Title lines={["Клуб рядом —", "даже когда вы не в зале"]} />
            </div>
            <div className={h.tabs} role="tablist" aria-label="Экраны приложения">
              {APP_TABS.map((t) => (
                <button
                  key={t.id}
                  type="button"
                  role="tab"
                  aria-selected={t.id === tab.id}
                  className={`${h.tab} ${t.id === tab.id ? h.tabOn : ""}`}
                  onClick={() => setAppTab(t.id)}
                >
                  {t.label}
                </button>
              ))}
            </div>
          </div>

          <div className={h.app}>
            <div className={h.appCopy}>
              <h3>
                {tab.title.map((line) => (
                  <span key={line}>{line}</span>
                ))}
              </h3>
              <p>{tab.text}</p>
              <ul>
                {tab.points.map((p) => (
                  <li key={p}>{p}</li>
                ))}
              </ul>
              <Btn>Попробовать бесплатно</Btn>
            </div>
            <div className={h.phones} key={tab.id}>
              {tab.screens.map((src, i) => (
                <img
                  key={src}
                  src={`${MOCK}/${src}`}
                  alt={i === 1 ? `Приложение ${L.productName}: ${tab.title.join(" ")}` : ""}
                  className={i === 1 ? h.phoneMain : h.phoneSide}
                  loading="lazy"
                />
              ))}
            </div>
          </div>
          <p className={h.fine}>
            Реальные экраны {L.productName}. «Тигр» — пример клуба внутри
            приложения.
          </p>
        </div>
      </section>

      <section className={h.section}>
        <div className={`${h.wrap} ${h.split}`}>
          <div className={h.splitPhoto}>
            <img src={IMG.a} alt="Тренер и администраторы клуба сверяют расписание" loading="lazy" />
          </div>
          <div>
            <p className={h.kicker}>04 / Внутри сервиса</p>
            <Title lines={["Начните с главного.", "Остальное — по мере роста."]} />
            <p className={h.sub}>
              В первый день достаточно расписания, клиентов и журнала.
              Онлайн-оплату и приложение для клиентов подключите, когда
              понадобятся.
            </p>
            <div className={h.focus}>
              <span>Расписание</span>
              <span>Клиенты</span>
              <span>Журнал</span>
              <span>Абонементы</span>
            </div>
            <Link to={PATHS.features} className={h.link}>
              Все возможности ↗
            </Link>
          </div>
        </div>
      </section>

      <section className={`${h.section} ${h.soft}`}>
        <div className={`${h.wrap} ${h.aud}`}>
          <div>
            <p className={h.kicker}>05 / Для кого</p>
            <Title lines={["Ваш спорт.", "Ваш формат.", `Ваш ${L.productName}.`]} />
            <p className={h.sub} style={{ marginBottom: 28 }}>
              Одна студия или несколько площадок. Групповые занятия или
              индивидуальные тренировки. Начнём с вашей модели работы.
            </p>
            <Btn to={PATHS.audience}>Подобрать сценарий</Btn>
          </div>
          <div className={h.audGrid}>
            {NICHES.map(([name, NicheIcon, to]) => {
              const inner = (
                <>
                  <span className={h.audIcon} aria-hidden>
                    <NicheIcon size={22} />
                  </span>
                  {name}
                </>
              );
              if (isAudienceMenuPath(to)) {
                return (
                  <Link key={name} to={to} className={h.audCard}>
                    {inner}
                  </Link>
                );
              }
              return (
                <div key={name} className={`${h.audCard} ${h.audCardStatic}`}>
                  {inner}
                </div>
              );
            })}
          </div>
        </div>
      </section>

      <section className={h.section}>
        <div className={h.wrap}>
          <div className={h.headRow}>
            <div>
              <p className={h.kicker}>06 / Один день клуба</p>
              <Title lines={["Тетради и таблицы", "больше не нужны."]} />
            </div>
            <Link to={PATHS.audience} className={h.link}>
              Кому подходит ↗
            </Link>
          </div>

          <article className={`${h.card} ${h.case}`}>
            <div className={h.caseScreen}>
              <img
                src={`${MOCK}/mock-owner-journal.png`}
                alt={`Журнал посещений группы в ${L.productName}`}
                loading="lazy"
              />
            </div>
            <div>
              <span className={h.uiTag}>СЕКЦИЯ ЕДИНОБОРСТВ · МЛАДШАЯ ГРУППА</span>
              <h3>
                Тренер отмечает группу — остальное {L.productName} делает сам.
              </h3>
              <p>
                После занятия ничего не нужно переписывать. Пришедшие отмечены,
                занятия списаны с абонементов, родители видят посещение в
                приложении, а владелец — кто из клиентов должен.
              </p>
              <div className={h.caseSteps}>
                {[
                  ["01", "Журнал", "Тренер отмечает пришедших"],
                  ["02", "Абонементы", "Занятия списываются сами"],
                  ["03", "Родители", "Видят посещение и остаток"],
                ].map(([n, t, d]) => (
                  <div key={n}>
                    <strong>{n}</strong>
                    <b>{t}</b>
                    <span>{d}</span>
                  </div>
                ))}
              </div>
            </div>
          </article>

          <div className={`${h.grid2} ${h.mt}`}>
            <article className={h.card}>
              <h3>Конец месяца без обзвона</h3>
              <p>
                Родители сами видят, сколько занятий осталось, и оплачивают
                абонемент в приложении. У владельца — список должников в
                финансах, а не в голове администратора.
              </p>
              <p className={h.caseTags}>Абонементы • онлайн-оплата • долги</p>
            </article>
            <article className={h.card}>
              <h3>Тренировку перенесли</h3>
              <p>
                Администратор меняет время в расписании — клиенты получают
                push-уведомление. Не нужно писать каждому в мессенджер.
              </p>
              <p className={h.caseTags}>Расписание • уведомления • чат</p>
            </article>
          </div>
        </div>
      </section>

      <section className={h.section}>
        <div className={h.wrap}>
          <div className={h.head}>
            <p className={h.kicker}>07 / Почему {L.productName}</p>
            <Title lines={["Просто начать.", "Легко расти."]} />
            <p className={h.sub}>
              Одна секция или сеть клубов — {L.productName} подстраивается под
              размер и формат вашего бизнеса.
            </p>
          </div>
          <div className={h.grid4}>
            {PRINCIPLES.map(([PrincipleIcon, t, d]) => (
              <article key={t} className={h.card}>
                <span className={`${h.audIcon} ${h.principleIcon}`} aria-hidden>
                  <PrincipleIcon size={22} />
                </span>
                <h3>{t}</h3>
                <p>{d}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className={`${h.section} ${h.soft}`} id="pricing">
        <div className={h.wrap}>
          <div className={h.headRow}>
            <div>
              <p className={h.kicker}>08 / Тарифы</p>
              <Title lines={["Тариф под размер клуба.", "Модули — по мере роста."]} />
              <p className={h.sub}>
                Первые {TRIAL_DAYS} дней — полный доступ бесплатно, без
                привязки карты.
              </p>
            </div>
            <Link to={PATHS.pricing} className={h.link}>
              Сравнить тарифы ↗
            </Link>
          </div>
          <PlansCalculator plans={plans} modules={modules} />

          <p className={h.fine}>
            Тариф можно сменить в любой момент, модули подключаются в кабинете.
          </p>
        </div>
      </section>

      <section className={h.section}>
        <div className={h.wrap}>
          <div className={h.head}>
            <p className={h.kicker} id="register">
              09 / Регистрация
            </p>
            <Title lines={["Клуб готов к работе", "через пару минут"]} />
            <p className={h.sub}>
              Без заявок и ожидания менеджера. Регистрируетесь сами — и сразу
              настраиваете расписание.
            </p>
          </div>
          <InlineRegister />
        </div>
      </section>

      <section className={`${h.section} ${h.soft}`}>
        <div className={h.wrap}>
          <div className={h.head}>
            <p className={h.kicker}>10 / Люди за процессами</p>
            <Title lines={["Хорошо каждому.", "Сильнее вся команда."]} />
            <p className={h.sub}>
              У каждого свой кабинет и свои права доступа — никто не видит
              лишнего.
            </p>
          </div>
          <div className={h.grid4}>
            {ROLES.map(([img, t, d, tag]) => (
              <article key={t} className={h.role}>
                <img src={img} alt={`${t} спортивного клуба`} loading="lazy" />
                <h3>{t}</h3>
                <p>{d}</p>
                <em>{tag}</em>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className={h.section} id="faq">
        <div className={`${h.wrap} ${h.faqRow}`}>
          <div>
            <p className={h.kicker}>11 / Вопросы и ответы</p>
            <Title lines={["Частые", "вопросы"]} />
            <p className={h.sub}>
              Не нашли ответ? Напишите нам — поможем с запуском и переносом
              базы.
            </p>
            <div style={{ marginTop: 28 }}>
              <Btn to={PATHS.connect}>Задать вопрос</Btn>
            </div>
          </div>
          <FaqList items={FAQ} />
        </div>
      </section>
    </div>
  );
}
